import { Route, Switch } from "react-router-dom";

import BrandCartMinimumCompletionPage from "@faire/prototype-playground/workspace/ed/brand-cart-minimum-completion";
import BrandPageSideCartMinimumPage from "@faire/prototype-playground/workspace/ed/brand-page-side-cart-minimum";
import FirstOrderMinimumOpportunityPage from "@faire/prototype-playground/workspace/ed/first-order-minimum-opportunity";
import PostOrderDiscoveryPage from "@faire/prototype-playground/workspace/ed/post-order-discovery";
import ProductTileCartPeekPage from "@faire/prototype-playground/workspace/ed/product-tile-cart-peek";

export function EricDingRoutes() {
  return (
    <Switch>
      <Route path="/ed/brand-cart-minimum-completion" component={BrandCartMinimumCompletionPage} />
      <Route path="/ed/brand-page-side-cart-minimum" component={BrandPageSideCartMinimumPage} />
      <Route path="/ed/first-order-minimum-opportunity" component={FirstOrderMinimumOpportunityPage} />
      <Route path="/ed/post-order-discovery" component={PostOrderDiscoveryPage} />
      <Route path="/ed/product-tile-cart-peek" component={ProductTileCartPeekPage} />
    </Switch>
  );
}

export const slug = "ed";
